'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteEligibleEventsForPerson = exports.getEventsHistory = exports.getAwardsPredictorCountByEventLevel = exports.getAwardsCountByEventLevel = exports.getAllEventScores = exports.updateReleaseComments = exports.orderParticipants = exports.updateGroupFeeAssignedToEvent = exports.deleteGroupFeeAssignedToEvent = exports.getGroupFeeAssignedToEvent = exports.getEventsInResultsQueue = exports.getMedalRound = exports.getMedalRounds = exports.associateMedalRoundWithAdjudicator = exports.setAnnounced = exports.getAdjudicatorsForEvent = exports.sendEventToResults = exports.sendEventToQa = exports.sendEventToTabs = exports.resetEvent = exports.getEventsWithStatus = exports.getEligibleEventsForPerson = exports.getParticipants = exports.deleteEvent = exports.mergeEvents = exports.splitEvent = exports.updateEvent = exports.cachePlacements = exports.createEvent = exports.getEvents = exports.getEvent = undefined;

var _getEvent2 = require('./getEvent');

var _getEvent3 = _interopRequireDefault(_getEvent2);

var _getEvents2 = require('./getEvents');

var _getEvents3 = _interopRequireDefault(_getEvents2);

var _createEvent2 = require('./createEvent');

var _createEvent3 = _interopRequireDefault(_createEvent2);

var _cachePlacements2 = require('./cachePlacements');

var _cachePlacements3 = _interopRequireDefault(_cachePlacements2);

var _updateEvent2 = require('./updateEvent');

var _updateEvent3 = _interopRequireDefault(_updateEvent2);

var _splitEvent2 = require('./splitEvent');

var _splitEvent3 = _interopRequireDefault(_splitEvent2);

var _mergeEvents2 = require('./mergeEvents');

var _mergeEvents3 = _interopRequireDefault(_mergeEvents2);

var _deleteEvent2 = require('./deleteEvent');

var _deleteEvent3 = _interopRequireDefault(_deleteEvent2);

var _getParticipants2 = require('./getParticipants');

var _getParticipants3 = _interopRequireDefault(_getParticipants2);

var _getEligibleEventsForPerson2 = require('./getEligibleEventsForPerson');

var _getEligibleEventsForPerson3 = _interopRequireDefault(_getEligibleEventsForPerson2);

var _getEventsWithStatus2 = require('./getEventsWithStatus');

var _getEventsWithStatus3 = _interopRequireDefault(_getEventsWithStatus2);

var _resetEvent2 = require('./resetEvent');

var _resetEvent3 = _interopRequireDefault(_resetEvent2);

var _sendEventToTabs2 = require('./sendEventToTabs');

var _sendEventToTabs3 = _interopRequireDefault(_sendEventToTabs2);

var _sendEventToQa2 = require('./sendEventToQa');

var _sendEventToQa3 = _interopRequireDefault(_sendEventToQa2);

var _sendEventToResults2 = require('./sendEventToResults');

var _sendEventToResults3 = _interopRequireDefault(_sendEventToResults2);

var _getAdjudicatorsForEvent2 = require('./getAdjudicatorsForEvent');

var _getAdjudicatorsForEvent3 = _interopRequireDefault(_getAdjudicatorsForEvent2);

var _setAnnounced2 = require('./setAnnounced');

var _setAnnounced3 = _interopRequireDefault(_setAnnounced2);

var _associateMedalRoundWithAdjudicator2 = require('./associateMedalRoundWithAdjudicator');

var _associateMedalRoundWithAdjudicator3 = _interopRequireDefault(_associateMedalRoundWithAdjudicator2);

var _getMedalRounds2 = require('./getMedalRounds');

var _getMedalRounds3 = _interopRequireDefault(_getMedalRounds2);

var _getMedalRound2 = require('./getMedalRound');

var _getMedalRound3 = _interopRequireDefault(_getMedalRound2);

var _getEventsInResultsQueue2 = require('./getEventsInResultsQueue');

var _getEventsInResultsQueue3 = _interopRequireDefault(_getEventsInResultsQueue2);

var _getGroupFeeAssignedToEvent2 = require('./getGroupFeeAssignedToEvent');

var _getGroupFeeAssignedToEvent3 = _interopRequireDefault(_getGroupFeeAssignedToEvent2);

var _deleteGroupFeeAssignedToEvent2 = require('./deleteGroupFeeAssignedToEvent');

var _deleteGroupFeeAssignedToEvent3 = _interopRequireDefault(_deleteGroupFeeAssignedToEvent2);

var _updateGroupFeeAssignedToEvent2 = require('./updateGroupFeeAssignedToEvent');

var _updateGroupFeeAssignedToEvent3 = _interopRequireDefault(_updateGroupFeeAssignedToEvent2);

var _orderParticipants2 = require('./orderParticipants');

var _orderParticipants3 = _interopRequireDefault(_orderParticipants2);

var _updateReleaseComments2 = require('./updateReleaseComments');

var _updateReleaseComments3 = _interopRequireDefault(_updateReleaseComments2);

var _getAllEventScores2 = require('./getAllEventScores');

var _getAllEventScores3 = _interopRequireDefault(_getAllEventScores2);

var _getAwardsCountByEventLevel2 = require('./getAwardsCountByEventLevel');

var _getAwardsCountByEventLevel3 = _interopRequireDefault(_getAwardsCountByEventLevel2);

var _getAwardsPredictorCountByEventLevel2 = require('./getAwardsPredictorCountByEventLevel');

var _getAwardsPredictorCountByEventLevel3 = _interopRequireDefault(_getAwardsPredictorCountByEventLevel2);

var _getEventsHistory2 = require('./getEventsHistory');

var _getEventsHistory3 = _interopRequireDefault(_getEventsHistory2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.getEvent = _getEvent3.default;
exports.getEvents = _getEvents3.default;
exports.createEvent = _createEvent3.default;
exports.cachePlacements = _cachePlacements3.default;
exports.updateEvent = _updateEvent3.default;
exports.splitEvent = _splitEvent3.default;
exports.mergeEvents = _mergeEvents3.default;
exports.deleteEvent = _deleteEvent3.default;
exports.getParticipants = _getParticipants3.default;
exports.getEligibleEventsForPerson = _getEligibleEventsForPerson3.default;
exports.getEventsWithStatus = _getEventsWithStatus3.default;
exports.resetEvent = _resetEvent3.default;
exports.sendEventToTabs = _sendEventToTabs3.default;
exports.sendEventToQa = _sendEventToQa3.default;
exports.sendEventToResults = _sendEventToResults3.default;
exports.getAdjudicatorsForEvent = _getAdjudicatorsForEvent3.default;
exports.setAnnounced = _setAnnounced3.default;
exports.associateMedalRoundWithAdjudicator = _associateMedalRoundWithAdjudicator3.default;
exports.getMedalRounds = _getMedalRounds3.default;
exports.getMedalRound = _getMedalRound3.default;
exports.getEventsInResultsQueue = _getEventsInResultsQueue3.default;
exports.getGroupFeeAssignedToEvent = _getGroupFeeAssignedToEvent3.default;
exports.deleteGroupFeeAssignedToEvent = _deleteGroupFeeAssignedToEvent3.default;
exports.updateGroupFeeAssignedToEvent = _updateGroupFeeAssignedToEvent3.default;
exports.orderParticipants = _orderParticipants3.default;
exports.updateReleaseComments = _updateReleaseComments3.default;
exports.getAllEventScores = _getAllEventScores3.default;
exports.getAwardsCountByEventLevel = _getAwardsCountByEventLevel3.default;
exports.getAwardsPredictorCountByEventLevel = _getAwardsPredictorCountByEventLevel3.default;
exports.getEventsHistory = _getEventsHistory3.default;
var deleteEligibleEventsForPerson = exports.deleteEligibleEventsForPerson = function deleteEligibleEventsForPerson(person_id) {
  return {
    person_id: person_id,
    type: 'DELETE_ELIG_EVENTS_FOR_PERSON'
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/index.js
// module id = 21
// module chunks = 0